import axiosSso from "@/api/interceptor_sso";

// 员工列表
export function getAgentStaffs(params: any) {
  return axiosSso.get("/agent/staffs", { params });
}

// 新建员工
export function postAgentStaffs(data: any) {
  return axiosSso.post(`/agent/staffs`, data);
}

// 查看员工
export function getAgentStaffsId(params: any, id: any) {
  return axiosSso.get(`/agent/staffs/${id}`);
}

// 修改员工
export function putAgentStaffs(data: any) {
  return axiosSso.put(`/agent/staffs/${data.id}`, data);
}

// 重置密码
export function putStaffsRestsPwd(data: any) {
  return axiosSso.put(`/agent/staffs/${data.id}/reset-password`, data);
}

// 分配直客
export function postAgentStaffsAssignUser(data: any) {
  return axiosSso.post(`/agent/staffs/assign-user`, data);
}
